import React, { useState, useEffect, useRef, forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isNil, throttle } from 'lodash-es';

import Button from '../Buttons/Button';
import { useCombinedRef } from '../../hooks';

// eslint-disable-next-line prefer-arrow-callback
const SideModalContainer = forwardRef(function SideModalContainer({
  children,
  offsetTop,
  contentContainerRef,
  className,
  onScroll,
  onClose,
}, ref) {
  const sideModalRef = useRef();

  const [modalHeight, setModalHeight] = useState();

  // Effect for height calculation
  useEffect(() => {
    const handleResize = throttle(() => {
      const sidebarOffsetTop = isNil(offsetTop)
        ? sideModalRef.current.getBoundingClientRect().top
        : offsetTop;

      setModalHeight(window.innerHeight - sidebarOffsetTop);
    }, 250);

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [offsetTop]);

  return (
    <div
      ref={useCombinedRef(ref, sideModalRef)}
      style={{ height: modalHeight, top: offsetTop }}
      className={cx('side-modal-container', className)}
    >
      <div className="side-modal-container__overlay animation-fade-element" />
      <div className="side-modal-container__inner animation-slide-element">
        <Button
          size="lg"
          shape="square"
          variant="light"
          className="side-modal-container__close-btn"
          onClick={onClose}
        >
          <span className="hicon-close-2" />
        </Button>
        <div className="side-modal-container__content" ref={contentContainerRef} onScroll={onScroll}>
          {children}
        </div>
      </div>
    </div>
  );
});

SideModalContainer.propTypes = {
  children: T.node.isRequired,
  offsetTop: T.bool,
  contentContainerRef: T.object,
  className: T.string,
  onScroll: T.func,
  onClose: T.func,
};

export default SideModalContainer;
